import log from 'loglevel'
import axios from 'axios'
import Cache from '../../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class File {
  constructor() {
    log.info('[INFO] Initialize File Module')
    this.cache = new Cache()
  }

  fetchFiles(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params: {
          p: params.p,
          page_size: params.page_size,
          search: params.q,
        },
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/order/invoicing/attach/file/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch files')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch files')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchFile(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/order/invoicing/attach/file/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch file')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch file')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateFile(id, fileData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/order/invoicing/attach/file/${id}/`, fileData)
        .then(response => {
          log.debug('[DEBUG] Success to update file')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update file')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addFile(fileData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/order/invoicing/attach/file/', fileData)
        .then(response => {
          log.debug('[DEBUG] Success to add file')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add file')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteFile(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/order/invoicing/attach/file/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete file')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete file')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
